import {Auth0Provider} from "@auth0/auth0-react";
import {getAuthConfig} from "../../Auth/config";
import {useNavigate} from "react-router-dom";

const Auth0ProviderWithNavigate = ({children}) => {

    const config = getAuthConfig();
    const navigate = useNavigate();

    const onRedirectCallback = async (appState) => {
        navigate(appState?.returnTo || window.location.pathname);
    };

    const providerConfig = {
        domain: config.domain,
        clientId: config.clientId,
        authorizationParams: {
            redirect_uri: window.location.origin + '/callback',
            scope: config.scope,
            ...(config.audience ? { audience: config.audience } : null),
        },
        onRedirectCallback: onRedirectCallback
    };

    return (
        <Auth0Provider {...providerConfig}>
            {children}
        </Auth0Provider>
    );
};

export default Auth0ProviderWithNavigate;